// extracted by mini-css-extract-plugin
export default {"box":"index_box_E2UCv","tip":"index_tip_UYKkh","nanhai":"index_nanhai_BaJeN","map":"index_map_QDjXu"};